import { useState } from "react";
import QRCodeGenerator from "../qrcode/QRCodeGenerator";
import {
    Box, Button, Divider, Typography, Grid, Table,
    TableBody,
    TableContainer,
    TableRow,
    TableCell, useTheme
} from "@mui/material";
import qrcode from 'qrcode';
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import { tokens } from "../../../theme/theme";

const LabelChildRollDetails = ({ qrCodeValue, selectedProductDetails, company_id, mode, modulename }) => {
    const userPermissions = useUserPermissions();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [headerData, setheaderData] = useState({
        logo: process.env.PUBLIC_URL + '/Assets/images/ITC_logo.png',

    });

    function formatDate(dateString) {
        if (!dateString) return ''; // Handle null or undefined date
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits for day
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits for month
        const year = date.getFullYear(); // Get full year
        return `${day}-${month}-${year}`;
    }


    // call print QR Code
    const handleButtonClick1 = async () => {

        let isvalid = true;
        if (selectedProductDetails.child_reel_number === '') {
            isvalid = false;
        }

        if (isvalid == true) {

            const printWindow = window.open('', '_blank');
            try {
                // Generate HTML content for each QR code parentRollNumber
                // Generate QR code data URL
                const qrDataUrl = await generateQRCode(selectedProductDetails.child_reel_number);
                // Check if QR code generation was successful
                if (!qrDataUrl) {
                    console.error('Error generating QR code for value:', selectedProductDetails.child_reel_number);
                }
                // Write HTML content for the QR code to the print window
                printWindow.document.write(`

                <html>
                    <head>
                        <title>Printed Report</title>
                        <style>
                        body {
                            margin: 0;
                            padding: 0;
                            font-family: Arial, sans-serif;
                        }
                        .container {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 10px;
                            border: 1px solid #ccc;
                            box-sizing: border-box;
                        }
                        .qr-code {
                            width: 150px; /* Adjust as needed */
                        }
                        .bundle-details {
                            flex: 1;
                            margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                        }
                        .bundle-details h5 {
                            margin: 0;
                            font-size: 18px;
                        }
                        .bundle-details h6 {
                            margin: 5px 0;
                            font-size: 16px;
                        }
                        .details-table {
                                    display: grid;
                                    grid-template-columns: 150px auto;
                                    gap: 10px 20px;
                                    margin-top: 10px;
                                }
                                .details-table div {
                                    font-size: 16px;
                                }
                                .details-table .label {
                                    font-weight: bold;
                                }
                                .bundle-details hr {
                                    margin: 10px 0;
                                    border: 1px solid #ccc;
                                }    
                    </style>
                    </head>
                    <body>
                    <div class="container">
                    <div>
                        <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                        <h3>${selectedProductDetails.child_reel_number || 'XXXXXX0123'}</h3>
                    </div>

                     <div class="bundle-details">

                        <h5>CHILD REEL DETAILS</h5>
                            <hr/>
                       <div class="details-table">

                            <div class="label">DATE / SHIFT </div><div>:  ${selectedProductDetails.shift_date || ''} / ${selectedProductDetails.shift_code || ''}</div> 
                            <div class="label">REEL NUMBER</div><div>: ${selectedProductDetails.child_reel_number}</div>                              
                            <div class="label">QUALITY</div><div>: ${selectedProductDetails.item_code}</div> 
                            <div class="label">SIZE</div><div>: ${selectedProductDetails.width || '0'} X ${selectedProductDetails.length}</div>  
                            <div class="label">GSM</div><div>: ${selectedProductDetails.gsm}</div> 
                            <div class="label">REEL.WT (MT)</div><div>: ${selectedProductDetails.achieved_qty}</div> 
                            <div class="label">PARENT ROLL NUMBER</div><div>: ${selectedProductDetails.pr_number}</div> 
                            <div class="label">MO NO</div><div>: ${selectedProductDetails.mo_number}</div> 
                            <div class="label">MA NO</div><div>: ${selectedProductDetails.ma_number}</div> 
                            <div class="label">SO NO</div><div>: ${selectedProductDetails.indent_no}</div> 
                            <div class="label">CUSTOMER NAME</div><div>: ${selectedProductDetails.customer_name}</div> 
                            <div class="label">REMARKS</div><div>:</div>            
                        
                        </div>                         
                    </div>                   
                      
                </div>
                    </body>
                </html>
            
            
                
            `);

                // <h6>Size : ${size}</h6>
                // Close the print window and print the report
                // printWindow.document.close();
                // printWindow.print();
            } catch (error) {
                console.error('Error handling button click:', error);
            }


        }



    };


    // call print QR Code
    const handleButtonClick = async () => {

        let isvalid = true;

        if (selectedProductDetails.child_reel_number === '') {
            isvalid = false;
        }


        if (isvalid == true) {


            const printWindow = window.open('', '_blank');
            try {
                // Generate HTML content for each QR code parentRollNumber
                // Generate QR code data URL
                const qrDataUrl = await generateQRCode(selectedProductDetails.child_reel_number);
                // Check if QR code generation was successful
                if (!qrDataUrl) {
                    console.error('Error generating QR code for value:', selectedProductDetails.child_reel_number);
                }

                if (mode === 0) {

                    // Write HTML content for the QR code to the print window
                    printWindow.document.write(`
                    <html>
                        <head>
                            <title>Printed Report</title>
                            <style>
                                @page {
                                        size: 100mm 150mm; /* Portrait orientation */
                                        margin: 0; /* Remove margins for edge-to-edge printing */
                                }
                                body {
                                        margin-left: 1mm;
                                        padding: 0;
                                        font-family: Arial, sans-serif;
                                        display: flex;
                                        flex-direction: column;
                                        align-items: flex-start;
                                        justify-content: flex-start;
                                        box-sizing: border-box;
                                }
                                .labelx {
                                        width: 100mm;
                                        height: 150mm;
                                        /*padding: 3mm;*/
                                        box-sizing: border-box;
                                        /*border: 1px solid #000;*/
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: space-between;
                                    
                                }
                                
                            
                                .container {
                                    width: 100%;
                                    height: 100%;                                
                                    box-sizing: border-box;
                                }
                                .header {
                                    display: flex;
                                    align-items: center;                                    
                                }
                                .header img {
                                    width: 20mm;
                                    height: auto;
                                    margin-right: 10mm;
                                }
                                .company-details h4 {
                                    font-weight: bold;
                                    color: #01579b;
                                    margin: 0;
                                    font-size: 12px;
                                }
                                .marketed-by {
                                    text-align: center; /* Aligns all text in this div to the center */
                                }
                                .divider {
                                    width: 100%; /* Full width of the container */
                                    height: 1px; /* Thin line for the divider */
                                    background-color: #000; /* Black color for visibility */
                                    margin: 10px 0; /* Spacing above and below */
                                }
                                .details-table {
                                    width: 100%;
                                    border-collapse: collapse;
                                    
                                    font-size: 15px;
                                }
                                .details-table th, .details-table td {
                                    padding: 2mm;
                                    text-align: left;
                                    border: 1px solid #ccc;

                                    font-weight: bold;
                                }
                                .details-table th {
                                    background-color: #f2f2f2;
                                    font-weight: bold;
                                }
                                .qr-code-container {
                                    text-align: center;
                                    margin-top: 5mm;
                                }
                                .qr-code-container img {
                                    width: 30mm;
                                    height: auto;
                                }
                                .qr-code-container h3 {
                                    font-weight: bold;
                                    font-size: 12px;
                                    margin: 5mm 0 0 0;
                                }
                                .footer {
                                    text-align: center;
                                    margin-top: 5mm;
                                    font-size: 14px;
                                    font-weight: bold;
                                
                                }
                                .title {
                                    text-align: center;
                                     margin-top: 40mm;
                                    font-size: 10px;
                                    font-weight: bold;
                                
                                }    
                                    
                            </style>
                        </head>
                        <body>
                            <div class="labelx">
                                <div class="container">                                
                                    <!-- Header -->
                                    <div class="title">
                                        
                                    </div> 

                                    <!-- Product Details Table -->
                                    <table class="details-table">
                                        <tr>
                                            <th>PRODUCT</th>
                                            <td>${selectedProductDetails.item_code}</td>
                                        </tr>
                                        <tr>
                                            <th style="font-weight: bold;" >GSM</th>
                                            <td>${selectedProductDetails.gsm}</td>
                                        </tr>
                                         <tr>
                                            <th style="font-weight: bold;">SIZE (CM)</th>
                                            <td>
                                                ${selectedProductDetails.length === 0
                            ? selectedProductDetails.width || '0'
                            : `${selectedProductDetails.width || '0'} X ${selectedProductDetails.length || '0'}`}
                                            </td>
                                        </tr>                                        
                                        <tr>
                                            <th>REEL DIA (CM)</th>
                                            <td>${selectedProductDetails.reel_od}</td>
                                        </tr>
                                        <tr>
                                            <th>CORE DIA (inch)</th>
                                            <td>${selectedProductDetails.core_id}</td>
                                        </tr>
                                        <tr>
                                            <th>REEL NO.</th>
                                            <td>${selectedProductDetails.child_reel_number}</td>
                                        </tr>
                                        <tr>
                                            <th>NET WEIGHT (KG)</th>
                                            <td>${(selectedProductDetails.achieved_qty)}</td>
                                        </tr>

                                        <!-- Conditionally Add GROSS WEIGHT Row -->
                                        ${mode === 0 ? `
                                            <tr>
                                                <th>GROSS WEIGHT (KG)</th>
                                                <td>${(selectedProductDetails.gross_qty)}</td>
                                            </tr>
                                        ` : ''}
                                        <tr>
                                            <th>REMARKS</th>
                                            <td style="font-size:8px;">${(selectedProductDetails.party_remarks || '')}</td>
                                        </tr>

                                        <tr>
                                            <th style="font-weight: bold;">DATE</th>
                                            <td>${formatDate(selectedProductDetails.rw_shift_date)}</td>
                                        </tr>
                                    </table>            
                                

                                    <!-- Footer Section -->
                                    ${mode === 0 ? `
                                    <div class="footer">
                                        <h2>MADE IN INDIA</h2>
                                    </div>    
                                    ` : ''}            
                                </div>
                            </div>
                              <div class="labelx">
                                <div class="container">                                
                                    <!-- Header -->
                                    <div class="title">
                                       
                                    </div> 

                                    <!-- Product Details Table -->
                                    <table class="details-table">
                                        <tr>
                                            <th>PRODUCT</th>
                                            <td>${selectedProductDetails.item_code}</td>
                                        </tr>
                                        <tr>
                                            <th style="font-weight: bold;" >GSM</th>
                                            <td>${selectedProductDetails.gsm}</td>
                                        </tr>
                                         <tr>
                                            <th style="font-weight: bold;">SIZE (CM)</th>
                                            <td>
                                                ${selectedProductDetails.length === 0
                            ? selectedProductDetails.width || '0'
                            : `${selectedProductDetails.width || '0'} X ${selectedProductDetails.length || '0'}`}
                                            </td>
                                        </tr>                                        
                                        <tr>
                                            <th>REEL DIA (CM)</th>
                                            <td>${selectedProductDetails.reel_od}</td>
                                        </tr>
                                        <tr>
                                            <th>CORE DIA (inch)</th>
                                            <td>${selectedProductDetails.core_id}</td>
                                        </tr>
                                        <tr>
                                            <th>REEL NO.</th>
                                            <td>${selectedProductDetails.child_reel_number}</td>
                                        </tr>
                                        <tr>
                                            <th>NET WEIGHT (KG)</th>
                                            <td>${(selectedProductDetails.achieved_qty)}</td>
                                        </tr>

                                        <!-- Conditionally Add GROSS WEIGHT Row -->
                                        ${mode === 0 ? `
                                            <tr>
                                                <th>GROSS WEIGHT (KG)</th>
                                                <td>${(selectedProductDetails.gross_qty)}</td>
                                            </tr>
                                        ` : ''}
                                        <tr>
                                            <th>REMARKS</th>
                                            <td style="font-size:8px;">${(selectedProductDetails.party_remarks || '')}</td>
                                        </tr>

                                        <tr>
                                            <th style="font-weight: bold;">DATE</th>
                                            <td>${formatDate(selectedProductDetails.rw_shift_date)}</td>
                                        </tr>
                                    </table>            
                                

                                    <!-- Footer Section -->
                                    ${mode === 0 ? `
                                    <div class="footer">
                                        <h2>MADE IN INDIA</h2>
                                    </div>    
                                    ` : ''}            
                                </div>
                            </div>
                            
                        </body>
                    </html>
                `);
                }
                else {


                    const fontSize = selectedProductDetails.indent_no.split(",").length > 2 ? "12px" :
                        selectedProductDetails.indent_no.includes(",") ? "18px" : "inherit";  // Adjust font size if more than one value

                    let packagemode = '';
                    let ordertype = selectedProductDetails.order_type;
                    let sheet_count = selectedProductDetails.number_of_sheets;

                    if (selectedProductDetails.package_type === 'BDL' || selectedProductDetails.package_type === 'BUNDLE') {
                        packagemode = 'BUNDLE / ' + ordertype + ' - ' + sheet_count;
                    }
                    else if (selectedProductDetails.package_type === 'BP' || selectedProductDetails.package_type === 'BULK ON PALLET') {
                        packagemode = 'BULK ON PALLET / ' + ordertype + ' - ' + sheet_count;
                    }
                    else if (selectedProductDetails.package_type === 'RL') {
                        packagemode = 'REEL / ' + ordertype + ' - ' + sheet_count;
                    }
                    else {
                        packagemode = selectedProductDetails.package_type + ' / ' + ordertype + ' - ' + sheet_count;
                    }

                    // Write HTML content for the QR code to the print window
                    printWindow.document.write(`
                   <html>
                        <head>
                            <title>Printed Report</title>
                            <style>
                                @page {
                                        size: 100mm 150mm; /* Portrait orientation */
                                        margin: 0; /* Remove margins for edge-to-edge printing */
                                }
                                body {
                                        margin-left: 1mm;
                                        padding: 0;
                                        font-family: Arial, sans-serif;
                                        display: flex;
                                        flex-direction: column;
                                        align-items: flex-start;
                                        justify-content: flex-start;
                                        box-sizing: border-box;
                                }
                                .labelx {
                                        width: 100mm;
                                        height: 150mm;
                                        /*padding: 3mm;*/
                                        box-sizing: border-box;
                                        /*border: 2px solid #000;*/
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: space-between;
                                    
                                }                               
                            
                                .container {
                                    width: 100%;
                                    height: 100%;                                
                                    box-sizing: border-box;
                                }
                                .header {
                                    display: flex;
                                    align-items: center;                                    
                                }
                                .header img {
                                    width: 20mm;
                                    height: auto;
                                    margin-right: 10mm;
                                }
                                .company-details h4 {
                                    font-weight: bold;
                                    color: #01579b;
                                    margin: 0;
                                    font-size: 12px;
                                }
                                .marketed-by {
                                    text-align: center; /* Aligns all text in this div to the center */
                                }
                                .divider {
                                    width: 100%; /* Full width of the container */
                                    height: 1px; /* Thin line for the divider */
                                    background-color: #000; /* Black color for visibility */
                                    margin: 10px 0; /* Spacing above and below */
                                }
                                .details-table {
                                    width: 100%;
                                    border-collapse: collapse; /* removes double borders */
                                    font-size: 13px;
                                }
                                .details-table th, .details-table td {
                                    border: 1px solid black;   /* single clean border */
                                    padding: 4px;
                                    text-align: center;        /* align like sample */
                                    font-weight: bold;
                                    
                                }
                                .details-table th {
                                     background: white;         /* remove grey */
                                    text-transform: uppercase; /* matches sample */
                                }
                                .details-table td {
                                    padding: 2mm;
                                    text-align: left;
                                    
                                    font-weight: bold;
                                    word-wrap: break-word; /* Ensures long words are wrapped */
                                    white-space: normal; /* Allows text to break into multiple lines */
                                    max-width: 50mm; /* Adjust based on your label size */
                                }    
                                .qr-code-container {
                                    text-align: center;
                                    margin-top: 5mm;
                                }
                                .qr-code-container img {
                                    width: 30mm;
                                    height: auto;
                                }
                                .qr-code-container h3 {
                                    font-weight: bold;
                                    font-size: 12px;
                                    margin: 5mm 0 0 0;
                                }
                                .footer {
                                    text-align: center;
                                    margin-top: 5mm;
                                    font-size: 14px;
                                    font-weight: bold;
                                
                                }
                                .title {
                                    text-align: center;
                                   
                                    font-size: 10px;
                                    font-weight: bold;
                                
                                }   
                                     .title1 {
                                    text-align: center;
                                  
                                    font-size: 10px;
                                    font-weight: bold;
                                
                                }    
                                    
                            </style>
                        </head>
                        <body>
                            <div class="labelx">
                                <div class="container">                                
                                    <!-- Header -->
                                <div class="title">
                                        <h2>REEL PROCESS CARD </h2>
                                    </div> 

                                    <!-- Product Details Table -->
                                    <table class="details-table">
                                        <tr>
                                            <th style="font-weight: bold; text-align: left">DATE</th>
                                            <td>${formatDate(selectedProductDetails.shift_date)}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">REEL NO</th>
                                            <td  style="font-size:30;font-weight: bold;">${selectedProductDetails.child_reel_number}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">JUMBO NO</th>
                                            <td>${selectedProductDetails.pr_number}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">PRODUCT</th>
                                            <td>${selectedProductDetails.item_code}</td>
                                        </tr>
                                        <tr>
                                            <th style="font-weight: bold;  text-align: left" >GSM</th>
                                            <td>${selectedProductDetails.gsm}</td>
                                        </tr>
                                         <tr>
                                            <th style="font-weight: bold; text-align: left">REEL SIZE (CM)</th>
                                            <td>${selectedProductDetails.master_reel || '0'}</td>
                                        </tr>
                                        <tr>
                                            <th style="font-weight: bold; text-align: left">CUSTOMER SIZE </th>
                                           <td>
                                                ${selectedProductDetails.length === 0
                                                    ? selectedProductDetails.width || '0'
                                                    : `${selectedProductDetails.width || '0'} X ${selectedProductDetails.length || '0'}`}
                                            </td>

                                        </tr> 
                                        <tr>
                                            <th style="font-weight: bold; text-align: left">LENGTH (M)</th>
                                            <td>${Math.floor(selectedProductDetails.reel_length) || '0'}</td>
                                        </tr>                                        
                                        <tr>
                                            <th style=" text-align: left">NET WEIGHT (KG)</th>
                                            <td>${(selectedProductDetails.achieved_qty)}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">ORDER NO</th>
                                            <td style="font-size: ${fontSize};">${(selectedProductDetails.indent_no)}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">MACHINE NO</th>
                                            <td style="font-size: ${fontSize};">${(selectedProductDetails.machine)}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">PACK MODE</th>
                                            <td style="font-size: ${fontSize};">${(packagemode)}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">REMARKS</th>
                                            <td style="font-size: ${fontSize}; word-wrap: break-word; white-space: normal; max-width: 50mm;">${(selectedProductDetails.remarks || '')}</td>
                                        </tr>

                                        <!-- Conditionally Add GROSS WEIGHT Row -->
                                        ${mode === 0 ? `
                                            <tr>
                                                <th style=" text-align: left">GROSS WEIGHT (KG)</th>
                                                <td>${(selectedProductDetails.gross_qty)}</td>
                                            </tr>
                                        ` : ''}                                    
                                       
                                    </table> 
                                    
                                    </table>   
                                              <!-- NEW Pallate/Sheet/F.No/Ream Table -->
                                               <table class="details-table">
                                                <thead>
                                                    <tr>
                                                    <th>Pallate</th>
                                                    <th>Sheet</th>
                                                    <th>F. No</th>
                                                    <th>Ream</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                    <td>A</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    </tr>
                                                    <tr>
                                                    <td>B</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    </tr>
                                                </tbody>
                                                </table>     
                                

                                    <!-- Footer Section -->
                                    ${mode === 0 ? `
                                    <div class="footer">
                                        <h2>MADE IN INDIA</h2>
                                    </div>    
                                    ` : ''}            
                                </div>
                            </div>
                              <div class="labelx">
                                <div class="container">                                
                                    <!-- Header -->
                                <div class="title">
                                        <h2>REEL PROCESS CARD</h2>
                                    </div> 

                                    <!-- Product Details Table -->
                                    <table class="details-table">
                                        <tr>
                                            <th style="font-weight: bold; text-align: left">DATE</th>
                                            <td>${formatDate(selectedProductDetails.shift_date)}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">REEL NO</th>
                                            <td style="font-size:30;font-weight: bold;">${selectedProductDetails.child_reel_number}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">JUMBO NO</th>
                                            <td>${selectedProductDetails.pr_number}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">PRODUCT</th>
                                            <td>${selectedProductDetails.item_code}</td>
                                        </tr>
                                        <tr>
                                            <th style="font-weight: bold; text-align: left" >GSM</th>
                                            <td>${selectedProductDetails.gsm}</td>
                                        </tr>
                                         <tr>
                                            <th style="font-weight: bold; text-align: left">REEL SIZE (CM)</th>
                                            <td>${selectedProductDetails.master_reel || '0'}</td>
                                        </tr>
                                        <tr>
                                            <th style="font-weight: bold; text-align: left">CUSTOMER SIZE </th>
                                            <td>
                                                ${selectedProductDetails.length === 0
                                                ? selectedProductDetails.width || '0'
                                                : `${selectedProductDetails.width || '0'} X ${selectedProductDetails.length || '0'}`}
                                            </td>
                                        </tr> 
                                        <tr>
                                            <th style="font-weight: bold; text-align: left">LENGTH (M)</th>
                                            <td>${Math.floor(selectedProductDetails.reel_length) || '0'}</td>
                                        </tr>                                        
                                        <tr>
                                            <th style=" text-align: left">NET WEIGHT (KG)</th>
                                            <td>${(selectedProductDetails.achieved_qty)}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">ORDER NO</th>
                                            <td style="font-size: ${fontSize};">${(selectedProductDetails.indent_no)}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">MACHINE NO</th>
                                            <td style="font-size: ${fontSize};">${(selectedProductDetails.machine)}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">PACK MODE</th>
                                            <td style="font-size: ${fontSize};">${(packagemode)}</td>
                                        </tr>
                                        <tr>
                                            <th style=" text-align: left">REMARKS</th>
                                            <td style="font-size: ${fontSize}; word-wrap: break-word; white-space: normal; max-width: 50mm;">${(selectedProductDetails.remarks || '')}</td>
                                        </tr>

                                        <!-- Conditionally Add GROSS WEIGHT Row -->
                                        ${mode === 0 ? `
                                            <tr>
                                                <th style=" text-align: left">GROSS WEIGHT (KG)</th>
                                                <td>${(selectedProductDetails.gross_qty)}</td>
                                            </tr>
                                        ` : ''}
                                       
                                    </table> 

                                    </table>   
                                              <!-- NEW Pallate/Sheet/F.No/Ream Table -->
                                                <table class="details-table">
                                                <thead>
                                                    <tr>
                                                    <th>Pallate</th>
                                                    <th>Sheet</th>
                                                    <th>F. No</th>
                                                    <th>Ream</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                    <td>A</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    </tr>
                                                    <tr>
                                                    <td>B</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    </tr>
                                                </tbody>
                                                </table>     
                                    

                                    <!-- Footer Section -->
                                    ${mode === 0 ? `
                                    <div class="footer">
                                        <h2>MADE IN INDIA</h2>
                                    </div>    
                                    ` : ''}            
                                </div>
                            </div>
                            
                        </body>
                    </html>


                `);

                }

            } catch (error) {
                console.error('Error handling button click:', error);
            }

            printWindow.document.close();
            printWindow.print();
        }
    };

    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };

//    padding: 2mm;
//                                     text-align: left;
//                                     border: 2px solid black;

//                                     font-weight: bold;


    return (<>

        {company_id === 1 ? (<>
            <Box mb={1}>
                <Typography variant="h5" textAlign="center">Child Roll Details</Typography>
            </Box>
            <Divider sx={{ marginBottom: "10px" }} />

            <Grid container spacing={0} justifyContent="space-between" alignItems="center">
                <Grid item xs={12} lg={8}>
                    <Grid container spacing={0}>
                        {/* Date and Shift */}
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">{`DATE / SHIFT `}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={7}>
                            <Typography variant="h7">: {` ${selectedProductDetails.shift_date || ''} / ${selectedProductDetails.shift_code || ''}`}</Typography>
                        </Grid>

                        {/* Quantity */}
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">REEL NUMBER </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">: {selectedProductDetails.child_reel_number}</Typography>
                        </Grid>

                        {/* GSM */}
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">QUALITY </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={7}>
                            <Typography variant="h7">: {selectedProductDetails.item_code}</Typography>
                        </Grid>

                        {/* No. Set */}
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">SIZE </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">: {selectedProductDetails.width}X{selectedProductDetails.length}</Typography>
                        </Grid>

                        {/* ID / OD */}
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">GSM </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">: {selectedProductDetails.gsm}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">REEL.WT (MT)</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">: {selectedProductDetails.achieved_qty}</Typography>
                        </Grid>

                        {/* TOTAL SHEETS */}
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">PARENT ROLL NUMBER</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">: {selectedProductDetails.pr_number || 0}</Typography>
                        </Grid>
                        {/* mo */}
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">MO NO</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">: {selectedProductDetails.mo_number || 0}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">MA NO</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">: {selectedProductDetails.ma_number || 0}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">SO NO</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">: {selectedProductDetails.indent_no || 0}</Typography>
                        </Grid>

                        {/* TOTAL SHEETS */}
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">CUSTOMER NAME</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">: {selectedProductDetails.customer_name || 0}</Typography>
                        </Grid>


                        {/* SUPPLIER :*/}
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">REMARKS </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={5}>
                            <Typography variant="h7">: </Typography>
                        </Grid>

                    </Grid>
                </Grid>

                {/* QR Code */}
                <Grid item xs={12} lg={4} textAlign="center">
                    <Typography variant="h7">{selectedProductDetails.child_reel_number}</Typography>
                    <QRCodeGenerator value={selectedProductDetails.child_reel_number} />
                </Grid>
            </Grid>
            <Divider sx={{ marginTop: "5px", marginBottom: "5px" }} />

            {hasPermission(userPermissions, modulename, "Print") && (
                <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                    <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={handleButtonClick}>Print</Button>
                </Box>
            )}
        </>) : company_id === '13' ? (<>
            {/* <Box sx={{ padding: 0 }}>
                <Grid container alignItems="center" spacing={1}>
                   
                    <Grid item xs={12} sm={3} md={2} lg={2} marginRight="auto" textAlign="left" >
                        <Box >
                            <img
                                src={headerData.logo}
                                alt="Mill Logo"
                                style={{ width: '100px', height: 'auto' }}
                            />
                        </Box>

                    </Grid>


                    
                    <Grid item xs={12} sm={9} md={10} lg={10}>
                        <Box marginLeft={7}>
                            <Typography variant="subtitle1" fontWeight="bold" color="#01579b">PAPERBOARDS</Typography>
                            <Typography variant="subtitle1" fontWeight="bold" color="#01579b">AND</Typography>
                            <Typography variant="subtitle1" fontWeight="bold" color="#01579b">SPECIALTY</Typography>
                            <Typography variant="subtitle1" fontWeight="bold" color="#01579b">PAPERS DIVISION</Typography>
                        </Box>
                    </Grid>
                </Grid>

                <Divider sx={{ marginY: 1 }} />

                <Box mb={2} textAlign="center">
                    <Typography variant="h6" fontWeight="bold" >Marketed By:</Typography>
                    <Typography variant="h6" fontWeight="bold">ITC Limited</Typography>
                    <Typography variant="h6" fontWeight="bold">106, SP Road, Secunderabad</Typography>
                    <Typography variant="h6" fontWeight="bold">Telangaa - 500003</Typography>
                    <Typography variant="h6" fontWeight="bold">Phone: 91-40-27846566-73</Typography>
                </Box>

                <TableContainer>
                    <Table>
                        <TableBody>
                            {[
                                { label: "PRODUCT", value: selectedProductDetails.item_code, font: "bold" },
                                { label: "GSM", value: selectedProductDetails.gsm, font: "bold" },
                                { label: "SIZE", value: selectedProductDetails.width, font: "bold" },
                                { label: "REEL DIA (CM)", value: selectedProductDetails.reel_od, font: "bold" },
                                { label: "CORE DIA (CM)", value: selectedProductDetails.core_id, font: "bold" },
                                { label: "REEL NO.", value: selectedProductDetails.child_reel_number, font: "bold" },
                                { label: "NET WEIGHT (KG)", value: selectedProductDetails.order_qty, font: "bold" },
                                ...(mode === 0 ? [
                                    { label: "GROSS WEIGHT (KG)", value: selectedProductDetails.achieved_qty, font: "bold" }
                                ] : []), 
                                { label: "DATE", value: formatDate(selectedProductDetails.shift_date), font: "bold" },
                            ].map((item, idx) => (
                                <TableRow key={idx}>
                                    <TableCell
                                        align="left"
                                        sx={{
                                            border: '1px solid black',
                                            fontWeight: item.font === "bold" ? "bold" : "normal",
                                            width: '40%',
                                        }}
                                    >
                                        <Typography variant="subtitle1">{item.label}</Typography>
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        sx={{
                                            border: '1px solid black',
                                            padding: 1,
                                            fontSize: 6,
                                        }}
                                    >
                                        <Typography variant="subtitle1">{item.value}</Typography>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box textAlign="center" marginTop={2}>
                    <Typography variant="h4" fontWeight="bold">MADE IN INDIA</Typography>
                </Box>
                <Divider sx={{ marginTop: "5px", marginBottom: "5px" }} />

                {hasPermission(userPermissions, "Winder Machine Production", "Print") && (
                    <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                        <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={handleButtonClick}>Print</Button>
                    </Box>
                )}
            </Box> */}

            {mode === 0 ? (<>
                <Box sx={{ padding: 2, backgroundColor: "#f5f5f5" }}>
                    <Grid container alignItems="center" spacing={1}>
                        {/* Logo */}
                        <Grid item xs={12} sm={3} md={2} lg={1} xl={1} marginRight="auto" textAlign="left">
                            <Box>
                                <img
                                    src={headerData.logo}
                                    alt="Mill Logo"
                                    style={{ maxWidth: '75px', height: 'auto', objectFit: 'contain' }} // Ensuring the logo scales properly
                                />
                            </Box>
                        </Grid>

                        {/* Company Details */}
                        <Grid item xs={12} sm={9} md={11} lg={11}>
                            <Box marginLeft={7}>
                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.9rem', xl: '0.9rem' } }}>
                                    PAPERBOARDS
                                </Typography>
                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.9rem', xl: '0.9rem' } }}>
                                    AND
                                </Typography>
                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.9rem', xl: '0.9rem' } }}>
                                    SPECIALTY
                                </Typography>
                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.9rem', xl: '0.9rem' } }}>
                                    PAPERS DIVISION
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>




                    <Divider sx={{ borderColor: "black", marginTop: "5px", marginBottom: "5px" }} />


                    {/* Marketed By Information */}
                    <Box mb={2} textAlign="center">
                        <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>Marketed By:</Typography>
                        <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>ITC Limited</Typography>
                        <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>106, SP Road, Secunderabad</Typography>
                        <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>Telangaa - 500003</Typography>
                        <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>Phone: 91-40-27846566-73</Typography>
                    </Box>
                    <Box
                        gridColumn="span 9"
                        gridRow="span 2"
                        alignItems="center"
                        justifyContent="center"
                        padding={1}
                        sx={{
                            "& .MuiTable-root": {
                                border: "none",
                                size: "small",
                            },
                            "& .MuiTableCell-root": {
                                borderBottom: "none",
                                border: "1px solid",
                                borderColor: `${colors.primary[400]} !important`,
                                padding: "2px",  // Further reduced padding
                            },
                            "& .MuiTableHead-root": {
                                borderBottom: "none",
                            },
                            "& .MuiTableBody-root": {
                                overflowY: "auto",
                            },
                            "& .MuiCheckbox-root": {
                                color: `${colors.blueAccent[200]} !important`,
                                size: "small",
                            },
                            "& .MuiTableFooter-root": {
                                borderTop: "none",
                                backgroundColor: colors.blueAccent[700],
                                height: "10px",
                            },
                            "& .MuiButton-text": {
                                color: `${colors.grey[100]} !important`,
                            },
                        }}
                    >

                        {/* Product Details Table */}
                        <TableContainer>
                            <Table>
                                <TableBody>
                                    {[
                                        { label: "PRODUCT", value: selectedProductDetails.item_code, font: "bold" },
                                        { label: "GSM", value: selectedProductDetails.gsm, font: "bold" },
                                        { label: "SIZE (CM)", value: `${selectedProductDetails.width || '0'} X ${selectedProductDetails.length}`, font: "bold" },
                                        { label: "REEL DIA (CM)", value: selectedProductDetails.reel_od, font: "bold" },
                                        { label: "CORE DIA (inch)", value: selectedProductDetails.core_id, font: "bold" },
                                        { label: "REEL NO.", value: selectedProductDetails.child_reel_number, font: "bold" },
                                        { label: "NET WEIGHT (KG)", value: (selectedProductDetails.achieved_qty), font: "bold" },
                                        ...(mode === 0 ? [
                                            { label: "GROSS WEIGHT (KG)", value: (selectedProductDetails.gross_qty), font: "bold" }
                                        ] : []),
                                        { label: "REMARKS", value: selectedProductDetails.party_remarks || '', font: "bold" },
                                        {
                                            label: "DATE", value: formatDate(
                                                selectedProductDetails.rw_shift_date && selectedProductDetails.rw_shift_date !== "0001-01-01T00:00:00"
                                                    ? selectedProductDetails.rw_shift_date
                                                    : selectedProductDetails.shift_date
                                            ), font: "bold"
                                        }
                                    ].map((item, idx) => (
                                        <TableRow key={idx}>
                                            <TableCell
                                                align="left"
                                                sx={{
                                                    border: '1px solid black',
                                                    fontWeight: item.font === "bold" ? "bold" : "normal",
                                                    width: '40%',
                                                }}
                                            >
                                                <Typography variant="subtitle1" color="black" fontWeight="bold" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>{item.label}</Typography>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                sx={{
                                                    border: '1px solid black',
                                                    // padding: 1,
                                                    fontSize: { xs: '0.7rem', sm: '0.9rem' },
                                                }}
                                            >
                                                <Typography variant="subtitle1" color="black" fontWeight="bold" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>{item.value}</Typography>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    {/* Footer */}
                    <Box textAlign="center" marginTop={2}>
                        <Typography variant="h4" fontWeight="bold" color="black" sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>MADE IN INDIA</Typography>
                    </Box>

                    <Divider sx={{ borderColor: "black", marginTop: "5px", marginBottom: "5px" }} />

                    {/* Print Button (conditional render based on permissions) */}
                    {hasPermission(userPermissions, modulename, "Print") && (
                        <>

                            {mode === 0 ? (
                                <>
                                    {selectedProductDetails.gross_qty > 0 && (
                                        <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                                            <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={handleButtonClick}>
                                                Print
                                            </Button>
                                        </Box>
                                    )}
                                </>
                            ) : (<>
                                <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                                    <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={handleButtonClick}>
                                        Print
                                    </Button>
                                </Box>
                            </>)}
                        </>
                    )}
                </Box>
            </>) : (<>
                <Box sx={{ padding: 2, backgroundColor: "#f5f5f5" }}>
                    <Grid container alignItems="center" spacing={1}>
                        {/* Logo */}
                        {/* <Grid item xs={12} sm={3} md={2} lg={1} xl={1} marginRight="auto" textAlign="left">
                            <Box>
                                <img
                                    src={headerData.logo}
                                    alt="Mill Logo"
                                    style={{ maxWidth: '75px', height: 'auto', objectFit: 'contain' }} // Ensuring the logo scales properly
                                />
                            </Box>
                        </Grid> */}

                        {/* Company Details */}
                        {/* <Grid item xs={12} sm={9} md={11} lg={11}>
                            <Box marginLeft={7}>
                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.9rem', xl: '0.9rem' } }}>
                                    PAPERBOARDS
                                </Typography>
                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.9rem', xl: '0.9rem' } }}>
                                    AND
                                </Typography>
                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.9rem', xl: '0.9rem' } }}>
                                    SPECIALTY
                                </Typography>
                                <Typography variant="subtitle1" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.9rem', xl: '0.9rem' } }}>
                                    PAPERS DIVISION
                                </Typography>
                            </Box>
                        </Grid> */}
                    </Grid>




                    {/* <Divider sx={{ borderColor: "black", marginTop: "5px", marginBottom: "5px" }} /> */}


                    {/* Marketed By Information */}
                    {/* <Box mb={2} textAlign="center">
                        <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>Marketed By:</Typography>
                        <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>ITC Limited</Typography>
                        <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>106, SP Road, Secunderabad</Typography>
                        <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>Telangaa - 500003</Typography>
                        <Typography variant="h6" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>Phone: 91-40-27846566-73</Typography>
                    </Box> */}
                    <Box
                        gridColumn="span 9"
                        gridRow="span 2"
                        alignItems="center"
                        justifyContent="center"
                        padding={1}
                        sx={{
                            "& .MuiTable-root": {
                                border: "none",
                                size: "small",
                            },
                            "& .MuiTableCell-root": {
                                borderBottom: "none",
                                border: "1px solid",
                                borderColor: `${colors.primary[400]} !important`,
                                padding: "2px",  // Further reduced padding
                            },
                            "& .MuiTableHead-root": {
                                borderBottom: "none",
                            },
                            "& .MuiTableBody-root": {
                                overflowY: "auto",
                            },
                            "& .MuiCheckbox-root": {
                                color: `${colors.blueAccent[200]} !important`,
                                size: "small",
                            },
                            "& .MuiTableFooter-root": {
                                borderTop: "none",
                                backgroundColor: colors.blueAccent[700],
                                height: "10px",
                            },
                            "& .MuiButton-text": {
                                color: `${colors.grey[100]} !important`,
                            },
                        }}
                    >

                        {/* Product Details Table */}
                        <TableContainer>
                            <Table>
                                <TableBody>
                                    {[
                                        { label: "DATE", value: formatDate(selectedProductDetails.shift_date), font: "bold" },
                                        { label: "REEL NO.", value: selectedProductDetails.child_reel_number, font: "bold" },
                                        { label: "JUMBO NO.", value: selectedProductDetails.pr_number, font: "bold" },
                                        { label: "PRODUCT", value: selectedProductDetails.item_code, font: "bold" },
                                        { label: "GSM", value: selectedProductDetails.gsm, font: "bold" },
                                        { label: "REEL SIZE (CM)", value: `${selectedProductDetails.master_reel || '0'} `, font: "bold" },
                                        {
                                            label: "CUSTOMER SIZE",
                                            value: selectedProductDetails.length === 0
                                                ? `${selectedProductDetails.width || '0'}`
                                                : `${selectedProductDetails.width || '0'} X ${selectedProductDetails.length || '0'}`,
                                            font: "bold"
                                        },
                                        { label: "LENGTH (M)", value: selectedProductDetails.reel_length || '0', font: "bold" },

                                        { label: "NET WEIGHT (KG)", value: (selectedProductDetails.achieved_qty), font: "bold" },
                                        ...(mode === 0 ? [
                                            { label: "GROSS WEIGHT (KG)", value: (selectedProductDetails.gross_qty), font: "bold" }
                                        ] : []),
                                        { label: "ORDER NO", value: selectedProductDetails.indent_no || '0', font: "bold" },
                                        { label: "MACHINE NO", value: selectedProductDetails.machine || '', font: "bold" },
                                        {
                                            // label: "PACK MODE", value:

                                            //     selectedProductDetails.package_type === 'BDL' || selectedProductDetails.package_type === 'BUNDLE'
                                            //         ? 'BUNDLE / ' + selectedProductDetails.order_type + ' - ' + selectedProductDetails.number_of_sheets ? selectedProductDetails.number_of_sheets : ''
                                            //         : selectedProductDetails.package_type === 'BP' || selectedProductDetails.package_type === 'BULK ON PALLET'
                                            //             ? 'BULK ON PALLET / ' + selectedProductDetails.order_type+ ' - ' + selectedProductDetails.number_of_sheets ? selectedProductDetails.number_of_sheets : ''
                                            //             : selectedProductDetails.package_type === 'RL'
                                            //                 ? 'REEL / ' + selectedProductDetails.order_type+ ' - ' + selectedProductDetails.number_of_sheets ? selectedProductDetails.number_of_sheets : ''
                                            //                 : selectedProductDetails.package_type + ' / ' + selectedProductDetails.order_type+ ' - ' + selectedProductDetails.number_of_sheets ? selectedProductDetails.number_of_sheets : ''
                                            label: "PACK MODE",
                                            value: (() => {
                                                const type = selectedProductDetails.package_type;
                                                const order = selectedProductDetails.order_type || '';
                                                const sheets = selectedProductDetails.number_of_sheets || '';

                                                if (type === 'BDL' || type === 'BUNDLE') {
                                                    return `BUNDLE / ${order} - ${sheets}`;
                                                } else if (type === 'BP' || type === 'BULK ON PALLET') {
                                                    return `BULK ON PALLET / ${order} - ${sheets}`;
                                                } else if (type === 'RL') {
                                                    return `REEL / ${order} - ${sheets}`;
                                                } else {
                                                    return `${type} / ${order} - ${sheets}`;
                                                }
                                            })()

                                        },
                                        { label: "REMARKS", value: selectedProductDetails.remarks || '', font: "bold" },
                                    ].map((item, idx) => (
                                        <TableRow key={idx}>
                                            <TableCell
                                                align="left"
                                                sx={{
                                                    border: '1px solid black',
                                                    fontWeight: item.font === "bold" ? "bold" : "normal",
                                                    width: '40%',
                                                }}
                                            >
                                                <Typography variant="subtitle1" color="black" fontWeight="bold" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' } }}>{item.label}</Typography>
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                sx={{
                                                    border: '1px solid black',
                                                    fontSize: { xs: '0.7rem', sm: '0.9rem' },
                                                    ...(item.label === "REMARKS" && {
                                                        wordWrap: 'break-word',
                                                        whiteSpace: 'normal',
                                                        overflowWrap: 'break-word',
                                                        maxWidth: '150px',
                                                    }),
                                                }}
                                            >
                                                <Typography
                                                    variant="subtitle1"
                                                    color="black"
                                                    fontWeight="bold"
                                                    sx={{
                                                        fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem', xl: '0.6rem' },
                                                        ...(item.label === "REMARKS" && {
                                                            wordWrap: 'break-word',
                                                            whiteSpace: 'normal',
                                                            overflowWrap: 'break-word',
                                                        }),
                                                    }}
                                                >
                                                    {item.value}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    {/* Footer */}
                    <Box textAlign="center" marginTop={2}>
                        <Typography variant="h4" fontWeight="bold" color="black" sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>MADE IN INDIA</Typography>
                    </Box>

                    <Divider sx={{ borderColor: "black", marginTop: "5px", marginBottom: "5px" }} />

                    {/* Print Button (conditional render based on permissions) */}
                    {hasPermission(userPermissions, modulename, "Print") && (
                        <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                            <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={handleButtonClick}>
                                Print
                            </Button>
                        </Box>
                    )}
                </Box>
            </>)}
        </>) : null}



    </>);
}
export default LabelChildRollDetails;